exports.components = {
  "component---src-pages-404-index-js": () => import("./../../../src/pages/404/index.js" /* webpackChunkName: "component---src-pages-404-index-js" */),
  "component---src-templates-content-index-jsx": () => import("./../../../src/templates/content/index.jsx" /* webpackChunkName: "component---src-templates-content-index-jsx" */)
}

